// extracted by mini-css-extract-plugin
export default {"section":"ClientStoriesSection_section__5N48O","heading":"ClientStoriesSection_heading__UUuUt","scrollContainer":"ClientStoriesSection_scrollContainer__VPXxB"};